<template>
    <div>
        <table class="table table-bordered mb-0">
            <tbody>
            <tr>
                <th class="text-center align-middle" style="width: 20%">课程名称</th>
                <td class="text-left align-middle" style="width: 80%">{{courseInfo.courseName}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 20%">课程类别</th>
                <td class="text-left align-middle" style="width: 80%">{{courseInfo.courseCategoryName}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 20%">基础要求</th>
                <td class="text-left align-middle" style="width: 80%">{{courseInfo.requirement}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 20%">教学目标</th>
                <td class="text-left align-middle" style="width: 80%">{{courseInfo.objective}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 20%">课程内容</th>
                <td class="text-left align-middle" style="width: 80%">{{courseInfo.courseContent}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 20%">备注</th>
                <td class="text-left align-middle" style="width: 80%">{{courseInfo.memo}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";
export default {
    props: {
        courseId: {type: String, required: true},
    },
    name: "OrganCourseInfoView",
    data: function () {
        return {
            courseInfo: {}
        };
    },
    mounted() {
        this.getCourseInfo();
    },
    methods: {
        getCourseInfo() {
            userApi.organ.course.getOrganCourseInfoById(this.courseId).then(res => {
                this.courseInfo = res.data;
            })
        }
    }
}
</script>

<style scoped>

</style>